export enum PainType {
  CHRONIC = 'CHRONIC',
  ACUTE = 'ACUTE',
}
